import {
  Component,
  HostListener,
  inject,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { map } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import dayjs from 'dayjs';

import { AudioService } from '../../services/audio.service';
import { PlanningRepository } from '../../data/planning/planning.repository';
import { EntryEditorComponent } from '../components/entry-editor/entry-editor.component';
import { TimeFrame } from '../../tools/date';
import { windowDebug } from '../../tools/debug';
import { Title } from '@angular/platform-browser';
import { EntryApi } from '../../data/entry/entry.api';
import { TopicRepository } from '../../data/topic/topic.repository';
import { TopicApi } from '../../data/topic/topic.api';
import { EntryRepository } from '../../data/entry/entry.repository';
import { Tables } from '../../data/database.types';
import { IntroComponent } from '../intro/intro.component';
import { ModalController } from '@ionic/angular';
import { DayService } from '../../data/day/day.service';
import { TopicAndEntryMaybe } from '../../data/day/topic-and-entry-maybe';
import { Topic } from '../../data/topic/topic';

const focusModeStorageKey = 'focusModeEnabled';

@Component({
  selector: 'app-day',
  templateUrl: './day.component.html',
  styleUrls: ['./day.component.scss'],
  providers: [DayService],
})
export class DayComponent implements OnInit {
  @ViewChildren(EntryEditorComponent) entryEditors:
    | QueryList<EntryEditorComponent>
    | undefined;

  private modalController = inject(ModalController);
  dayService = inject(DayService);

  trackByTopicAndEntryMaybe = (index: number, vm: TopicAndEntryMaybe) =>
    vm.topic.id;

  focusedTopicId: number | undefined;

  date$ = this.dayService.date$;

  dateIsYesterday$ = this.date$.pipe(map((x) => dayjs(x).isYesterday()));

  focusModeEnabled = false;

  @HostListener('window:keydown.f')
  toggleFocusMode() {
    if (this.focusedTopicId) {
      return;
    }
    this.focusModeEnabled = !this.focusModeEnabled;
    localStorage.setItem(
      focusModeStorageKey,
      JSON.stringify(this.focusModeEnabled),
    );
  }

  constructor(
    private route: ActivatedRoute,
    private planningRepository: PlanningRepository,
    private audio: AudioService,
    private title: Title,
    private entryRepository: EntryRepository,
    private entryApi: EntryApi,
    private topicApi: TopicApi,
    private topicRepository: TopicRepository,
  ) {
    windowDebug('DayComponent', this);

    const focusModeEnabledRaw = localStorage.getItem(focusModeStorageKey);
    if (focusModeEnabledRaw) {
      this.focusModeEnabled = JSON.parse(focusModeEnabledRaw);
    }
  }

  ngOnInit() {
    this.topicApi.topicsExist().then((exists) => {
      if (!exists) {
        this.showIntroModal();
      }
    });

    this.date$.pipe().subscribe((date) => {
      this.planningRepository.setFetchTimeFrame(
        new TimeFrame(dayjs(date).toDate(), 'day'),
      );
      this.entryApi.fetchEntriesByDate(date);
    });
  }

  ionViewDidEnter() {
    this.title.setTitle('dc3 | mein tag');
  }

  ionViewWillEnter() {
    // this.showManifest();
  }

  // showManifest() {
  //   this.modalController.create({
  //     component: ManifestComponent,
  //     backdropDismiss: true,
  //     keyboardClose: true
  //   }).then(modal => modal.present());
  // }

  addTempTopic(topicId: number) {
    this.topicRepository.addTemp(topicId);
    setTimeout(() => {
      this.scrollToAndFocusTopic(topicId);
      this.audio.plop();
    });
  }

  async createNewTopicAndAddTempTopic(topicName: any) {
    if (topicName) {
      const newTopic = await this.topicApi.add(topicName);
      // this.topicRepository.upsertTopics([newTopic]);
      this.addTempTopic(newTopic.id);
    }
  }

  onEditorFocused(topicId: number) {
    this.focusedTopicId = topicId;
  }

  updateTopics(topics: Topic[]) {
    // optimistic repo upsert to prevent flickering
    this.topicRepository.upsert(topics);
    this.topicApi.upsertMultiple(topics);
  }

  scrollToAndFocusTopic(topicId: number) {
    if (this.entryEditors) {
      const editorComponent = this.entryEditors.find(
        (editorCmp) => editorCmp.topic.id === topicId,
      );

      if (!editorComponent) {
        throw Error('This should not happen!');
      }

      if (editorComponent.localContent === null) {
        editorComponent.showInputAndFocus();
      }
    }
  }

  private showIntroModal() {
    this.modalController
      .create({
        component: IntroComponent,
      })
      .then((modal) => modal.present());
  }
}
